<template>
    <CardPage :section="7" :page="6" :backOverrideFunction="backClick" ref="cardPage">
        <v-slide-x-reverse-transition hide-on-leave>
            <div v-if="'pick' === mode">
                <p>This situation is really messed up. Pick from the list below to provide Queenie with advice about what she should do:</p>
                <div v-for="(key, index) in responsesOrder" :key="index" class="grey lighten-3 pa-3 mb-1" @click.stop="select(responses[key])" v-ripple>
                    {{ responses[key].text }}
                </div>
            </div>
        </v-slide-x-reverse-transition>
        <v-slide-x-reverse-transition hide-on-leave>
            <div v-if="'response' === mode">
                <div v-if="'aggressive' === response.type">
                    <video controls controlslist="nodownload" @playing="playingAggressive" @ended="endedAggressive">
                        <source :src="require('@/assets/videos/Video07_aggressive.mp4')" type="video/mp4" />
                        <track kind="captions" srclang="en" :src="require('@/assets/videos/Video07_aggressive.vtt')" />
                    </video>
                    <p v-if="aggressiveStarted && aggressiveCompleted" class="mt-3">
                        Well… that didn’t work out so well. Queenie is now having to try and find healthcare somewhere else… That’s an aggressive response!
                    </p>
                </div>
                <div v-if="'passive' === response.type">
                    <p>
                        Queenie doesn’t do anything in response, just leaves the clinic without treatment and is still in pain… That’s a passive response!
                    </p>
                </div>
                <div v-if="'assertive' === response.type">
                    <video controls controlslist="nodownload" @playing="playingAssertive" @ended="endedAssertive">
                        <source :src="require('@/assets/videos/Video07_assertive.mp4')" type="video/mp4" />
                        <track kind="captions" srclang="en" :src="require('@/assets/videos/Video07_assertive.vtt')" />
                    </video>
                    <div v-if="assertiveStarted && assertiveCompleted">
                        <p class="mt-3">
                            After Queenie gets treatment for her stomach pains, she asked to see a manager about the nurse calling her sir. The manager promises
                            to address this with the nurse.
                        </p>
                        <p>
                            Good job! You know your Mother makes sure she gets what she needs and advocates for other trans patients by using an assertive
                            response. But also, just because I decided to educate others, doesn’t mean you have to. Trans people are not responsible for
                            educating people about transness.
                        </p>
                    </div>
                </div>
            </div>
        </v-slide-x-reverse-transition>
        <template v-if="'response' === mode && response.isCorrect" v-slot:actions>
            <v-spacer></v-spacer>
            <v-btn round large color="primary" @click="nextClick()" :disabled="nextDisabled()">Next</v-btn>
            <v-spacer></v-spacer>
        </template>
        <template v-else-if="'response' === mode && !response.isCorrect" v-slot:actions>
            <v-spacer></v-spacer>
            <v-btn round large color="primary" @click="tryAgain()" :disabled="tryAgainDisabled()">Try again!</v-btn>
            <v-spacer></v-spacer>
        </template>
        <template v-else v-slot:actions>
            <v-spacer></v-spacer>
        </template>
    </CardPage>
</template>

<script>
import router from '@/router';
import { get } from 'vuex-pathify';

export default {
    data() {
        return {
            mode: 'pick',
            response: null,
            aggressiveStarted: false,
            aggressiveCompleted: false,
            assertiveStarted: false,
            assertiveCompleted: false
        };
    },
    computed: {
        responses: get('section7/responses'),
        responsesOrder: get('section7/responsesOrder')
    },
    methods: {
        backClick() {
            if ('pick' === this.mode) {
                router.back();
            } else {
                this.tryAgain();
            }
        },
        select(response) {
            this.response = response;
            this.mode = 'response';
        },
        nextClick() {
            this.$refs.cardPage.nextClick();
        },
        tryAgain() {
            this.response = null;
            this.mode = 'pick';
        },
        nextDisabled() {
            return this.response && this.response.type === 'assertive' && (!this.assertiveStarted || !this.assertiveCompleted);
        },
        tryAgainDisabled() {
            return this.response && this.response.type === 'aggressive' && (!this.aggressiveStarted || !this.aggressiveCompleted);
        },
        playingAggressive() {
            this.aggressiveStarted = true;
        },
        endedAggressive() {
            this.aggressiveCompleted = true;
        },
        playingAssertive() {
            this.assertiveStarted = true;
        },
        endedAssertive() {
            this.assertiveCompleted = true;
        }
    }
};
</script>

<style scoped>
video {
    width: 100% !important;
    height: auto !important;
}
</style>
